import * as React from "react";
import { CouponType } from "../../../../services/banner";
import { getLitbLangFn } from "utils/language/index";
import Toast from "../../../../components/Toast";
import { LTReceiveToast } from "../../../../components/LTReceiveToast";

interface ToastProps {
	type: CouponType;
	status: number;
	language: string;
	handleClose: () => void;
}

interface CopyToastProps {
	language: string;
	handleClose: () => void;
}

const CopyToast = (props: CopyToastProps) => {
	const { language = "en", handleClose } = props;
	React.useEffect(() => {
		setTimeout(() => {
			handleClose();
		}, 3000);
	}, []);
	return <Toast message={`${getLitbLangFn("Coupon successfully copied", language)}`} />;
};

export const CouponToast = (props: ToastProps) => {
	const { type, status, language, handleClose } = props;

	if (type === CouponType.CopyCoupon) {
		return <CopyToast language={language} handleClose={handleClose} />;
	}
	return <LTReceiveToast isMobile={true} status={status} lang={language} onClose={handleClose} />;
};
